import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CONST } from "@/utils/const";
import { alarmReadClear } from "@/api/bjsz";
export default {
  name: "Warnmsg",
  data: function data() {
    return {
      ws: null,
      alarmCount: 0,
      alarmMessages: [],
      isSpeechPaused: true,
      speechSynthesis: window.speechSynthesis,
      currentUtterance: null,
      isSpeaking: false
    };
  },
  computed: {
    wsData: function wsData() {
      var one = this.$store.getters["ws/group"].alarm;
      return one ? one.data : [];
    }
  },
  watch: {
    alarmCount: function alarmCount(newVal, oldVal) {
      if (newVal === 0 || newVal === oldVal) return;
      var message = "\u6709".concat(newVal, "\u6761\u8B66\u544A\u7B49\u5F85\u5904\u7406");
      if (!this.isSpeechPaused) {
        this.speakText(message);
      }
    },
    wsData: {
      handler: function handler(val) {
        if (!val || !Object.keys(val).length || val.sendUserId !== "systemUser") {
          return;
        }
        this.processWsMessage(val);
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    // this.initWebSocket();
    // 检测浏览器是否支持语音合成
    if (!this.speechSynthesis) {
      console.warn("当前浏览器不支持语音合成功能");
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanUp();
  },
  methods: {
    // 初始化WebSocket连接
    // initWebSocket() {
    //   const url = `${CONST.APIURL.WS.alarm}/${this.$store.state.user.uniqueId}/${this.$store.state.user.userId}`;
    //   this.$store.dispatch("ws/loadWS", { url: url, name: "alarm" });
    // },
    // 处理WebSocket消息
    processWsMessage: function processWsMessage(wsData) {
      if (wsData.code !== 200) return;
      var areaIds = this.$store.state.user.areaIds;
      if (areaIds && areaIds.length > 0 && wsData.data && wsData.data.length > 0) {
        this.alarmMessages = wsData.data.filter(function (item) {
          // 检查推送数据的 areaIds 中，是否有任何一个在用户的 areaIds 中
          return item.areaIds && item.areaIds.some(function (areaId) {
            return areaIds.includes(areaId);
          });
        });
        this.alarmCount = this.alarmMessages.length > 0 ? wsData.alarmCount : 0;
      } else {
        this.alarmCount = wsData.alarmCount || 0;
        this.alarmMessages = wsData.data || [];
      }
      if (this.alarmCount > 0 && !this.isSpeechPaused) {
        this.speakAlarmMessages();
      }
    },
    // 播报警告消息
    speakAlarmMessages: function speakAlarmMessages() {
      if (this.alarmMessages.length === 0) return;
      var messages = this.alarmMessages.map(function (item) {
        return "\u5E8F\u53F7".concat(item.sortId, "\u7684\u8BBE\u5907\uFF0C").concat(item.terminalName, "\uFF0C").concat(item.alarmMsg, "\u3002");
      }).join(" ");
      this.speakText(messages);
    },
    // 语音播报文本
    speakText: function speakText(text) {
      var _this = this;
      if (!this.speechSynthesis || this.isSpeaking) return;
      this.stopSpeech();
      var utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = "zh-CN";
      utterance.rate = 1.5;
      utterance.volume = 1;
      utterance.onend = function () {
        _this.isSpeaking = false;
      };
      utterance.onerror = function (event) {
        // console.error("语音播报出错:", event);
        _this.isSpeaking = false;
      };
      this.currentUtterance = utterance;
      this.isSpeaking = true;
      this.speechSynthesis.speak(utterance);
    },
    // 停止当前语音播报
    stopSpeech: function stopSpeech() {
      if (this.speechSynthesis && this.isSpeaking) {
        this.speechSynthesis.cancel();
        this.isSpeaking = false;
      }
    },
    // 切换语音播报状态
    toggleSpeech: function toggleSpeech() {
      this.isSpeechPaused = !this.isSpeechPaused;
      if (!this.isSpeechPaused) {
        if (this.alarmCount > 0) {
          this.speakAlarmMessages();
        } else {
          this.speakText("当前没有警告");
        }
      } else {
        this.stopSpeech();
      }
    },
    // 进入告警列表页面
    enterWarnList: function enterWarnList() {
      if (this.$refs.popover) {
        this.$refs.popover.doClose();
      }
      this.$router.push({
        path: "/bjsz/list"
      });
      this.readAll();
    },
    // 标记所有告警为已读
    readAll: function readAll() {
      var _this2 = this;
      alarmReadClear().then(function (res) {
        if (res.code === 200) {
          _this2.alarmCount = 0;
          _this2.stopSpeech();
        }
      });
    },
    // 清理资源
    cleanUp: function cleanUp() {
      this.stopSpeech();
      // this.$store.dispatch("ws/destroyWS", "alarm");
    }
  }
};